(function(){
  function money(cents){
    var v = (cents/100);
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  async function getCart(){
    var r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
    return await r.json();
  }

  function init(){
    // Hook: if theme already has shipping progress + upsells, we don't override.
    // This file is reserved for future MCW-specific cart enhancements if needed.
    // Keeping it lightweight on purpose.
  }

  document.addEventListener('DOMContentLoaded', init);
})();